import Swiper from 'swiper/bundle';

if (document.querySelectorAll(".slide-notes-container")) {
	document.querySelectorAll(".slide-notes-container").forEach(slide => {
		new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 32,
			centeredSlides: true,
			grabCursor: 'true',


			navigation: {
				nextEl: slide.querySelector(".swiper-button-next"),
				prevEl: slide.querySelector(".swiper-button-prev"),
			},
		});
	});
}
